import type { ReactNode } from "react";
import { BrandLoader } from "@/components/shared/BrandLoader";
import { useLayoutVersion } from "./LayoutVersionContext";

interface LayoutSwitchProps {
  /** Elemento do layout novo (página lazy: só baixa se for escolhida). */
  next: ReactNode;
  /** Elemento do layout legado (`src/legacy/`). */
  legacy: ReactNode;
}

/** Mesma URL, versão pela chave da organização (D3). Enquanto a chave carrega, nunca mostra a versão errada. */
export function LayoutSwitch({ next, legacy }: LayoutSwitchProps) {
  const version = useLayoutVersion();
  if (version === "loading") return <BrandLoader variant="fullscreen" />;
  return <>{version === "new" ? next : legacy}</>;
}
